import { Condition } from 'api/models/FieldTemplate';
import { RecoilState, atom } from 'recoil';

export const filterState: RecoilState<Condition[]> = atom<Condition[]>({
  key: 'filterState',
  default: [],
});
